<div class="card">
    <fp-logo-header [logoUrl]="logoUrl" [hideOnSmallScreen]="true"></fp-logo-header>
    <div class="card-body">
        <div *ngIf="error">
            <span [innerHTML]="error | translate:translateParams"></span>
        </div>
    </div>
</div>